import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import Banner from './component/banner'
import Footer from './component/footer'
import ANZUnitPricesOA from './view/ANZUnitPrices-OA'
import ANZUnitPricesANZ from './view/ANZUnitPrices-ANZ'
import ANZHistoricalUnitPricesANZ from './view/ANZHistoricalUnitPrices-ANZ'
import ANZHistoricalUnitPricesOA from './view/ANZHistoricalUnitPrices-OA'
import NotFound from "./view/NoutFound";
import DatePicker from './view/datePicker'
import './main.css'
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';

class Layout extends React.Component{
  constructor(props){
    super(props)
  }

  showIeErrorMessage = () =>{

      let isIE = false;
      let isEdge = window.navigator.userAgent.indexOf('Edge') != -1
      isIE = window.navigator.userAgent.indexOf('Trident') != -1 && !isEdge;

      if(isIE){
          return(
              <div className="container">
                  <div className="alert alert-danger" role="alert" style={{marginBottom: "0px" , marginTop:"110px"}}>
                      This page will not be compatible with Internet Explorer (IE11) from August. To continue viewing this page, please download and use the latest version of <a title="" href="https://www.google.com/chrome/" target="_blank">Chrome</a> or <a title="" href="https://www.microsoft.com/en-us/edge" target="_blank">Microsoft Edge</a>.
                  </div>
              </div>
          )
      }
};

  render(){
    return (
      <div class="app">
        <div className="Site">
            <Banner />
            <div class="Site-content">
                {this.showIeErrorMessage()}
              <Router>
                  <Switch>
                    <Route path="/UnitPrices" component ={ANZUnitPricesOA}></Route>
                    <Route path="/ANZUnitPrices" component ={ANZUnitPricesANZ}></Route>
                    <Route path="/ANZHistoricalUnitPrices" component ={ANZHistoricalUnitPricesANZ}></Route>
                    <Route path="/HistoricalUnitPrices" component ={ANZHistoricalUnitPricesOA}></Route>
                    <Route exact path='/'><Redirect to="/ANZUnitPrices" /></Route>
                      <Route component={NotFound}/>
                  </Switch>
              </Router>
            </div>
            <Footer />
        </div>
       </div>
    )
  }
}


ReactDOM.render(
    <Layout />,
    document.querySelector('#root')
);

